module.exports = __webpack_public_path__ + "static/img/dress.3c1ecf81.webp";